var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.dadosReady)?_c('Loading',{attrs:{"message":'a colaboração'}}):_c('EditaCredito',{attrs:{"t":_vm.credito}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }